import styled from 'styled-components';
import { baseTheme } from '../../../../../../global/styles/theme';

export const TabsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TabHint = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 6px;
  font-size: 12px;
  line-height: 1.4;
  color: ${baseTheme.colors.tertiary};

  &::before {
    content: 'ℹ️';
    font-size: 13px;
    line-height: 1.3;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  gap: 8px;
  overflow-x: auto;

  .tab-button {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 12px;
    border: 1px solid ${baseTheme.colors.stroking};
    background: ${baseTheme.colors.white};
    font-size: 14px;
    font-weight: 600;
    color: ${baseTheme.colors.secondary};
    cursor: pointer;
    white-space: nowrap;
    flex-shrink: 0;
    transition: border-color 0.15s, color 0.15s;

    &.active {
      border-color: ${baseTheme.colors.mainLightBlue};
      color: ${baseTheme.colors.mainLightBlue};
    }
  }

  .tab-count {
    min-width: 20px;
    padding: 1px 7px;
    border-radius: 50px;
    background: ${baseTheme.colors.stroking};
    font-size: 12px;
    font-weight: 700;
    color: ${baseTheme.colors.secondary};
    text-align: center;
  }

  .tab-button.active .tab-count {
    background: ${baseTheme.colors.mainLightBlue};
    color: ${baseTheme.colors.white};
  }
`;
